import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ExpertReportSubtitleWrapper = styled.span`
  display: flex;
  align-items: center;
  margin: ${Spacing.S8} 0;
`
